
// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyNumberCardPrepaidAccountBalance',

  props: {
    accountBalance: {
      type: String,
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyNumberCard/MyNumberCardPrepaidAccountBalance/component.js